import { render, staticRenderFns } from "./ResidentAutoPaymentTab.vue?vue&type=template&id=43585184&scoped=true&"
import script from "./ResidentAutoPaymentTab.vue?vue&type=script&lang=ts&"
export * from "./ResidentAutoPaymentTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43585184",
  null
  
)

export default component.exports